<template>
  <v-container class="pt-0" style="background-color: white" fluid>
    <v-row no-gutters justify="center">
      <v-col cols="12" md="6" justify="center" align="center">
        <span style="font-size: 30px; color: #616161">
          <v-icon large class="pr-1 pb-2">do_not_disturb_off</v-icon>
          Expeciones de revaluacion de periodos</span
        >
      </v-col>
    </v-row>
    <v-card flat class="pt-3">
      <v-data-table
        :loading="loading"
        item-key="accounting_period_id"
        :headers="headers"
        :items="exceptions"
        :search="search"
        height="65vh"
        loading-text="Cargando datos..."
        dense
        sort-by="accounting_period_id"
        fixed-header
        :items-per-page="60"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-col cols="3">
              <search-header
                class="mt-2"
                @dataFilters="changeBusiness($event)"
                :show_weeks="false"
                :show_location="false"
                :show_department="false"
                :show_refresh="false"
                :type="false"
              />
            </v-col>

            <v-spacer> </v-spacer>
            <v-text-field
              class="mt-3"
              dense
              label="Buscar.."
              v-model="search"
              append-icon="search"
              single-line
              hide-details
              outlined
            ></v-text-field>
            <v-spacer> </v-spacer>

            <v-btn
              v-if="lastData && lastData.business && hasFeature('CON-132')"
              outlined
              @click="openDialog"
              color="primary"
              dark
            >
              <v-icon small>add</v-icon>
              Nueva excepción
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <template v-if="hasFeature('CON-132')">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  medium
                  color="warning"
                  class="mx-1"
                  @click="editItem(item)"
                  >edit</v-icon
                >
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  medium
                  color="red"
                  class="mx-1"
                  @click="deleteItem(item)"
                  >delete</v-icon
                >
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>
          <span v-else class="text-caption grey--text">Solo lectura</span>
        </template>
        <template v-slot:no-data>
          <v-row justify="center" class="pt-10">
            <v-icon size="80px">token</v-icon>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5 primary--text">Cuenta contable a excepción</span>
          <v-spacer></v-spacer>
          <v-icon @click="dialog = false">close</v-icon>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-container>
            <v-row justify="center" class="pa-4 pb-4">
              <v-autocomplete
                dense
                item-value="id"
                item-text="name"
                v-model="editedItem.chart_of_account_id"
                :items="accounts"
                color="cyanText"
                label="Cuenta contable"
                outlined
                required
              ></v-autocomplete>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="mt-n10">
          <v-row no-gutters justify="center">
            <v-spacer></v-spacer>
            <v-btn @click="dialog = false" outlined text> Cancelar </v-btn>
            <v-spacer></v-spacer>
            <v-btn :loading="loading" @click="save" dark color="black">
              Guardar
            </v-btn>
            <v-spacer></v-spacer>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import moment from "moment";
export default {
  data: () => ({
    search: null,
    periods: [],
    exceptions: [],
    editedIndex: -1,
    dialog: false,
    editedItem: {},
    isNew: true,
    loading: false,
    current_calendar: 1,
    loading: false,
    item_loading: null,
    lastData: null,
    accounts: [],
    headers: [
      { text: "Codigo cuenta", value: "code" },
      { text: "Nombre", value: "name" },

      { text: "Opciones", value: "actions", sortable: false, align: "center" },
    ],
  }),
  created() {
    this.init();
  },
  // watch: {},
  methods: {
    async init() {
      let resultTypeAccounts = await this.api_Get("accounting/accountsUsable");
      let accounts = await resultTypeAccounts.json();
      accounts.forEach((element) => {
        element.name = element.name + " (" + element.code + ")";
        this.accounts.push({
          name: element.code + " - " + element.name,
          id: element.id,
        });
      });
    },
    openDialog(item) {
      this.editedItem = Object.assign({}, item);
      this.isNew = true;
      this.dialog = true;
    },
    changeBusiness(filters) {
      this.lastData = filters;
      this.exceptions = [];
      this.current_calendar = null;
      this.getExceptionBussines(filters);
    },
    getDate(date) {
      moment.locale("es");

      let newDate = moment(date).format("DD-MMMM-YYYY").toString();
      return newDate;
    },
    async getExceptionBussines(filters) {
      if (filters.business == null || filters.business == 0) {
        return;
      }
      this.exceptions = [];

      this.lastData = filters;
      const data = await this.api_Post("accounting/exceptions_bussiness", {
        id: filters.business,
      });
      let result = await data.json();

      this.exceptions = result;
    },
     
    async deleteItem(item) {
        const data = await this.api_Post(
          "accounting/delete_exceptions_bussiness",
          {
            business_unit_id: item.business_unit_id,
            chart_of_account_id: item.chart_of_account_id,
          }
        );
        let result = await data.json();
        if (result) {
          this.dialog = false;
          await this.getExceptionBussines(this.lastData);
        } else {
          this.$toast.error("Error al revaluar el periodo");
        }
    },
    async save() {
      if (this.editedItem.chart_of_account_id == null) {
        this.$toast.error("Debe seleccionar una cuenta contable");
        return;
      }
      this.loading = true;
      if (this.isNew == true) {
        const data = await this.api_Post(
          "accounting/add_exceptions_bussiness",
          {
            business_unit_id: this.lastData.business,
            chart_of_account_id: this.editedItem.chart_of_account_id,
          }
        );
        let result = await data.json();
        if (result) {
          this.dialog = false;
          await this.getExceptionBussines(this.lastData);
        } else {
          this.$toast.error("Error al revaluar el periodo");
        }
      } else {
        const data = await this.api_Post(
          "accounting/update_exceptions_bussiness",
          {
            business_unit_id: this.lastData.business,
            chart_of_account_id: this.editedItem.chart_of_account_id,
            last_chart_of_account_id: this.editedItem.last_chart_of_account_id,
          }
        );
        let result = await data.json();
        if (result) {
          this.dialog = false;
          await this.getExceptionBussines(this.lastData);
        } else {
          this.$toast.error("Error al revaluar el periodo");
        }
      }

      this.loading = false;
    },
    editItem(item) {
      this.editedIndex = this.exceptions.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.last_chart_of_account_id=item.chart_of_account_id
      this.dialog = true;
      this.isNew = false;
    },
  },
};
</script>
